import { DesktopDatePicker } from "@mui/lab";
import { TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { handleKeyDown } from "utils/keyDownPrevent";

interface Props {
  label?: string;
  name: string;
  size?: "small" | "medium";
  control: any;
  required?: boolean;
  maxDate?: Date | null;
  minDate?: Date | null;
  disabled?: boolean;
}

function FormDate(props: Props) {
  const { name, size = "small", control, disabled = false, label = "", required = false, maxDate, minDate } = props;

  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [forFocus, setForFocus] = useState(true);


  const handleFocus = () => {
    if (forFocus)
      setIsDatePickerOpen(true);
    setForFocus(true);
  };


  const handleSelect = () => {
    setIsDatePickerOpen(false);
    setForFocus(false);
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <DesktopDatePicker
              label={`${label} ${required ? "*" : ""}`}
              inputFormat="dd-MM-yyyy"
              mask="__-__-____"
              value={field.value}
              disabled={disabled}
              onChange={(date) => {
                field.onChange(date);
                handleSelect();

              }}
              open={isDatePickerOpen}
              maxDate={props.maxDate}
              // minDate={props.minDate}
              minDate={minDate || new Date(2000, 0, 1)}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  onKeyDown={handleKeyDown}
                  onClick={() => { setIsDatePickerOpen(true); }}
                  size={size}
                  {...params}
                  error={Boolean(error)}
                  onBlur={field.onBlur}
                  onFocus={() => {
                    handleFocus()

                  }}
                  autoComplete="off"

                />
              )}
            />
            {error && (
              <Typography variant="caption" sx={{ pl: "2px" }} color="rgb(211, 47, 47)">
                {error.message}
              </Typography>
            )}
          </>
        )}
      />
    </>
  );
}

export default FormDate;
